import { DeleteWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  ConnectorProvider,
  WorkflowNodeConnectorProvider,
} from '../../registry/connector-provider.registry';

@WorkflowNodeConnectorProvider('Delete')
export class DeleteConnectorProvider extends ConnectorProvider<DeleteWorkflowNode> {}
